export class WorkspaceStorageAccessConfiguration {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "WorkspaceAwsStorageAccessConfiguration",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceStorageAccessConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
